/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_TaglineInputs */

const es_home_hero_tagline = /** @type {(inputs: Home_Hero_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potenciado por Nexy, tu asistente de conocimiento`)
};

const en_home_hero_tagline = /** @type {(inputs: Home_Hero_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powered by Nexy, your knowledge assistant`)
};

/**
* | output |
* | --- |
* | "Powered by Nexy, your knowledge assistant" |
*
* @param {Home_Hero_TaglineInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_hero_tagline = /** @type {((inputs?: Home_Hero_TaglineInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_TaglineInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_tagline(inputs)
	return en_home_hero_tagline(inputs)
});
export { home_hero_tagline as "home.hero.tagline" }